var map = {
	"./buy_super_cn.png": "b344",
	"./buy_super_en.png": "1a3c",
	"./buy_super_id.png": "8d50",
	"./buy_super_ko.png": "94d4",
	"./buy_super_ph.png": "d82b",
	"./buy_super_th.png": "21b0",
	"./buy_super_zh.png": "b754"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8aa";